import { Button } from "@workspace/ui/components/button";
import {
	Drawer,
	DrawerContent,
	DrawerHeader,
	DrawerTitle,
	DrawerDescription,
	DrawerFooter,
} from "@workspace/ui/components/drawer";
import { Input } from "@workspace/ui/components/input";
import { useState } from "react";

import { api } from "../lib/dajia-client";
import { useSession } from "../lib/dajia-session";
import { setSessionKey } from "../lib/dajia-session-key";
export function PasswordDrawer({ onClose }: { onClose: () => void }) {
	const { refresh } = useSession();
	const [old, setOld] = useState(""),
		[password, setPassword] = useState(""),
		[confirm, setConfirm] = useState(""),
		[busy, setBusy] = useState(false),
		[error, setError] = useState("");
	const save = async () => {
		if (password.length < 8 || password !== confirm) {
			setError("新密码至少8位，且两次输入须一致。");
			return;
		}
		setBusy(true);
		setError("");
		try {
			const result = await api<{ session_key: string }>("password", "", {
				current_password: old,
				new_password: password,
			});
			setSessionKey(result.session_key);
			await refresh();
			onClose();
		} catch (e) {
			setError(e instanceof Error ? e.message : "修改未完成，请重试。");
		} finally {
			setBusy(false);
		}
	};
	return (
		<Drawer
			open
			swipeDirection="right"
			onOpenChange={(open) => {
				if (!open && !busy) {
					onClose();
				}
			}}
			disablePointerDismissal={busy}
		>
			<DrawerContent className="w-full bg-background sm:max-w-lg">
				<DrawerHeader className="border-b p-6">
					<DrawerTitle>修改密码</DrawerTitle>
					<DrawerDescription>
						修改后，其他设备需使用新密码重新登录。
					</DrawerDescription>
				</DrawerHeader>
				<div className="flex-1 space-y-5 p-6">
					<label className="grid gap-2 text-sm">
						原密码
						<Input
							aria-label="原密码"
							type="password"
							autoComplete="current-password"
							value={old}
							onChange={(e) => setOld(e.target.value)}
							maxLength={128}
						/>
					</label>
					<label className="grid gap-2 text-sm">
						新密码
						<Input
							aria-label="新密码"
							type="password"
							autoComplete="new-password"
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							minLength={8}
							maxLength={128}
						/>
					</label>
					<label className="grid gap-2 text-sm">
						确认新密码
						<Input
							aria-label="确认新密码"
							type="password"
							autoComplete="new-password"
							value={confirm}
							onChange={(e) => setConfirm(e.target.value)}
							maxLength={128}
						/>
					</label>
					{error && (
						<p role="alert" className="text-sm text-destructive">
							{error}
						</p>
					)}
				</div>
				<DrawerFooter className="flex-row justify-end border-t p-5">
					<Button variant="outline" disabled={busy} onClick={onClose}>
						取消
					</Button>
					<Button disabled={busy} onClick={() => void save()}>
						{busy ? "正在保存…" : "保存密码"}
					</Button>
				</DrawerFooter>
			</DrawerContent>
		</Drawer>
	);
}
